"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var SearchPublicTags = function SearchPublicTags(_ref) {
  var key = _ref.key,
      onInput = _ref.onInput;
  return (0, _preact.h)("div", {
    key: key,
    className: "tag-search-input-wrapper"
  }, (0, _preact.h)(_assets.default, {
    icon: "search",
    size: 18,
    color: "#6B707E"
  }), (0, _preact.h)("input", {
    type: "text",
    placeholder: "search",
    className: "form-control",
    onInput: onInput
  }));
};

var _default = SearchPublicTags;
exports.default = _default;